<div class="app-integration-account-manage-companies-grid__container">
  <div class="app-integration-account-manage-companies-grid__header">
    <div class="form-group w-60">
      <div class="lum-label">Map To</div>
      <mat-select
        class="lum-select"
        (selectionChange)="onCustomFilterChange($event.value, 'mapTo')"
        [value]="customFilters.mapTo || eAppIntegrationAccountCompanyFilter.ALL"
      >
        <mat-option [value]="eAppIntegrationAccountCompanyFilter.ALL">{{
          eAppIntegrationAccountCompanyFilter.ALL
        }}</mat-option>
        <mat-option [value]="eAppIntegrationAccountCompanyFilter.COMPANY">{{
          eAppIntegrationAccountCompanyFilter.COMPANY
        }}</mat-option>
        <mat-option [value]="eAppIntegrationAccountCompanyFilter.NOT_MAPPED">{{
          eAppIntegrationAccountCompanyFilter.NOT_MAPPED
        }}</mat-option>
      </mat-select>
    </div>

    <button
      class="lum-button"
      [disabled]="autoMapLoading"
      (click)="onAutoMapCompanies()"
    >
      <i
        class="fa fa-sync mr-2 text-small"
        [ngClass]="{ 'fa-spin': autoMapLoading }"
      ></i>
      Auto-Map Companies
    </button>
    <button class="lum-button sync-btn" (click)="onSyncCompanies()">
      <lum-ui-icon
        icon="programming-cloud-download"
        color="#ffffff"
        width="11"
        height="11"
        class="mr-2 text-small"
      ></lum-ui-icon>
      Get Companies
    </button>
    <button
      class="lum-button lum-button--secondary"
      [matMenuTriggerFor]="menu"
      [disabled]="!selectedRowNodeIds.length"
    >
      Bulk Actions
      <span *ngIf="selectedRowNodeIds.length">
        ({{ selectedRowNodeIds.length }})
      </span>
      <i class="flaticon-more ml-2"></i>
    </button>
    <mat-menu class="lum-mat-menu" #menu="matMenu">
      <button mat-menu-item (click)="onBulkCreateBusinessAccount()">
        Create Business Accounts
      </button>
    </mat-menu>
  </div>

  <div class="app-integration-account-manage-companies-grid__content">
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine ag-theme-lum"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
    >
    </ag-grid-angular>
  </div>
</div>
